import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { TNKDigitalContractComponent } from './digital-contract.component';
export class TNKDigitalContractModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    TNKUtilitiesModule,
    HttpClientModule,
    RouterModule,
  ],
  declarations: [TNKDigitalContractComponent],
  providers: [ApiConstant],
  exports: [TNKDigitalContractComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKDigitalContractModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKDigitalContractModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKDigitalContractModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
